var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),(_vm.device==='desktop')?_c('search-panel'):_vm._e(),(_vm.device==='mobile')?_c('search-mobile-panel'):_vm._e(),_c('search-result-area')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"texthead"},[_c('div',{staticClass:"container px-5"},[_c('h1',[_vm._v("הדר")])])])
}]

export { render, staticRenderFns }